export default {
  title: 'Cyber Defender',
  btn: 'Visit “Cyber Defender” Web Page',
  c1: 'one_tc.png',
  c2: 'two_tc.png',
  c3: 'three_tc.png',
  c4:"Reminder",
  c5:"You will open your mobile browser and go the website of 'Scameter'",
  c6:"Not now",
  c7:"OK",
  c8:"https://cyberdefender.hk/en-us/scameter/",
  c9:"Any Suspicious calls, phishing messages and suspected scam traps? The one-stop scam search and pitfall engine'Scameter+' can help you!Search the reports and risk records for suspicious URLs, phone numbers, platform accounts, and stay vigilant at all times! Click to view details and download",
}
